export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const APP_NAME = process.env.REACT_APP_STORE_NAME;
export const APP_LOGO = "../../../assets/images/logo.png";
export const BANNER_IMG = "assets/images/banner.png";
export const GLOBAL_CURRENCY = {
    symbol: "R",
    code: "ZAR",
    name: "South African Rand"
}
export const GLOBAL_COUNTRY_CODE = {
    "flag": "https://geo5.net/imagens/Bandeira-da-Africa-do-Sul.png",
    "name": "South Africa",
    "dial_code": "27",
    "code": "SA"
}

export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_API
export const TERMS_OF_SERVICE = 'https://www.venturestudiocms.com/api/general-pages/91?populate=hero_section.media, description.paragraphs.media,other_content_blocks.media,quick_links.cards.media'
export const PRIVACY_POLICY = 'https://www.venturestudiocms.com/api/general-pages/90?populate=hero_section.media, description.paragraphs.media,other_content_blocks.media,quick_links.cards.media'

// export const ENABLED_D6_FEATURE= ["d6auth.vercel.app"]
export const ENABLED_D6_FEATURE = [ "localhost:3001", "mclardies.webbieshop.com","d6auth.vercel.app","broadacreschartwell.webbieshop.com","broadacressyringa.webbieshop.com","qiatuckshop.webbieshop.com"]
export const IS_BETA = ["d6auth.vercel.app"]
export const IS_LIVE = ["mclardies.webbieshop.com"]
